/**
 * Initialize the Fluxible app for Item-level Feedback.
 * @type {Fluxible}
 */
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'js/l... Remove this comment to see the full error message
import setupFluxibleApp from 'js/lib/setupFluxibleApp';

import ItemFeedbackStore from 'bundles/content-feedback/stores/ItemFeedbackStore';
import ProgrammingGradingProblemsStore from 'bundles/content-feedback/stores/ProgrammingGradingProblemsStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export default (fluxibleContext: $TSFixMe) => {
  return setupFluxibleApp(fluxibleContext, (itemFeedbackApp: $TSFixMe) => {
    itemFeedbackApp.registerStore(CourseStore);

    itemFeedbackApp.registerStore(ItemFeedbackStore);
    itemFeedbackApp.registerStore(ProgrammingGradingProblemsStore);

    return fluxibleContext;
  });
};
